// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"563bfbb7","581":"b47dc930"}[chunkId] + ".chunk.js");